export default function AboutUs() {
  return (
    <section className="bg-[#E3F2F9] text-gray-800 py-16 text-center ">
      <h2 className="text-3xl font-bold">About us</h2>
      <div className="w-16 h-1 bg-red-500 mx-auto my-2"></div>
      <p className="text-description max-w-2xl mx-auto mt-4 px-6">
        We are a locally owned and operated house cleaning service proudly
        serving Huntsville, Madison, Owens Cross Roads, Athens and surrounding
        areas in Alabama.
      </p>
      <p className="text-description max-w-2xl mx-auto mt-4 px-6">
        When you call or text us with your cleaning needs, rest assured that we
        will make every effort to exceed your expectations.{" "}
        <strong>Your satisfaction is our priority.</strong>
      </p>
    </section>
  );
}
